// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__HAlWm","skins":"ProfilePage_skins__wVG8F","top":"ProfilePage_top__8fl7T"};